<template>
	<Layout>
		<Header>
			<b-button v-if="permissionEnabled('users', 'create')" type="is-secondary create" rounded @click="modalCreate($event)">
				<svg-icon icon="plus" class="icon is-small"></svg-icon>
				<span>{{ $t('buttons.add') }}</span>
			</b-button>
		</Header>
		<filter-default enable-search @filterSearch="filterSearch" />
		<Error v-if="errored" :icon="true" :back="true" />
		<Results v-if="lawyers.length == 0 && !loading" />
		<div v-if="loading" class="columns is-multiline">
			<div v-for="n in pagination" :key="n" class="column is-12-mobile is-6-tablet is-4-desktop">
				<Placeholder />
			</div>
		</div>
		<transition-group name="filtering" class="filtering columns is-multiline mb-5" tag="div">
			<div v-for="l in lawyers" :key="l.id" class="column is-12-mobile is-6-tablet is-4-desktop">
				<article class="block" @click.self="modalEdit(l.id)">
					<b-tag v-if="!l.approved" type="is-warning">{{ $tc('labels.not_approved') }}</b-tag>
					<div class="block__avatar cases is-48x48">
						<h4>{{ l.lawyer && l.lawyer.lawsuits ? l.lawyer.lawsuits.length : 0 }}</h4>
						<p>{{ l.lawyer && l.lawyer.lawsuits && l.lawyer.lawsuits.length > 1 ? 'Casos' : 'Caso' }}</p>
					</div>
					<div class="block__content">
						<h3 class="block__name link" @click="modalEdit(l.id)">{{ l.full_name }}</h3>
						<p class="block__email">{{ format(l.created_at) }} • {{ timeTo(l.created_at) }}</p>
					</div>
					<Trigger :id="l.id" page="lawyers" :lawyer="l" />
				</article>
			</div>
		</transition-group>
	</Layout>
</template>

<script>
import Layout from '@/layouts/Default'
import Header from '@/components/Header'
import Icon from '@/components/Icon'
import Placeholder from '@/components/placeholders/User'
import Trigger from '@/components/triggers/Lawyer'
import Error from '@/components/Error'
import Results from '@/components/Results'
import Modal from '@/components/modals/Lawyer'
import Api from '@/services/api'
import eventHub from '@/services/eventHub'
import { create, update } from '@/mixins/modal'
import { successToast, errorToast } from '@/mixins/toast'
import { mapGetters } from 'vuex'
import mixinApp from '@/mixins/app'
import FilterDefault from '@/components/FilterDefault'

export default {
	name: 'lawyersPage',
	components: {
		Layout,
		Header,
		Placeholder,
		Trigger,
		Error,
		Results,
		'svg-icon': Icon,
		FilterDefault
	},
	mixins: [
		mixinApp
	],
	data() {
		return {
			current: 1,
			page: 1,
			total: 0,
			pagination: 15,
			data: [],
			status: 1,
			loading: true,
			errored: false,
			permission: [],
			showPagination: false,
			filter: {
				name: ''
			}
		}
	},
	mounted() {
		this.getAllLawyers()
		eventHub.$on('edit-modal-lawyers', obj => {
			update(this, 'lawyers', obj.id, Modal, 'Edit', obj.root)
		})
		eventHub.$on('delete-lawyers', obj => {
			this.$buefy.dialog.alert({
				size: 'is-delete',
				type: 'is-outlined is-primary',
				title: this.$t('labels.warning'),
				message: '<span>' + this.$t('alerts.delete.confirmation') + '</span>',
				canCancel: true,
				focusOn: 'cancel',
				cancelText: this.$t('buttons.no'),
				confirmText: this.$t('buttons.yes'),
				onConfirm: async () => {
					try {
						const { status } = await Api.delete(`lawyers/destroy/${obj.id}`)
						if (status === 200) {
							successToast(this.$t('alerts.delete.success', [this.$tc('menu.lawyer')]))
							await this.getAllLawyers()
						} else {
							errorToast(this.$t('alerts.delete.error', [this.$tc('menu.lawyer')]))
						}
					} catch (e) {
						console.log(e)
					}
				}
			})
		})
		eventHub.$on('reload-lawyers', () => {
			this.getAllLawyers()
		})
	},
	computed: {
		lawyers() {
			const url = window.location.href.split('/')
			const type = url.find(el => el === 'page')
			if (type === 'page') {
				let current = this.current - 1
				return this.data.slice(current * this.pagination, (current + 1) * this.pagination)
			} else {
				let current = this.current - 1
				return this.data.slice(current * this.pagination, (current + 1) * this.pagination)
			}
		},
		...mapGetters('user', [
			'permissionEnabled'
		])
	},
	methods: {
		async getAllLawyers() {
			try {
				const response = await Api.get('lawyers/findAll')
				const { status } = response
				if (status === 200) {
					const { data } = response
					this.data = data
					this.total = data.length
					this.showPagination = this.total > 15 ? true : false
				}
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},
		async filterSearch(v) {
			try {
				this.filter.name = v
				if (v.length > 0) {
					const response = await Api.post('lawyers/findByName', {
						name: this.filter.name
					})
					const { status } = response
					if (status === 200) {
						const { data } = response
						this.data = data
						this.total = data.length
					}
				} else {
					await this.getAllLawyers()
				}
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},
		modalCreate() {
			if (this.permissionEnabled('lawyers', 'create')) {
				create(this, 'lawyers', Modal, 'New')
			}
		},
		modalEdit(id) {
			if (this.permissionEnabled('lawyers', 'edit')) {
				update(this, 'lawyers', id, Modal, 'Edit')
			}
		}
	}
}
</script>
